import { env } from "@src/config/env"

export const makeTitleWithSuffix = (title: string) => {
  return `${title} | ${env.config.projectName}`
}
